import { LinkTab, Tabs } from '@ygtechnologies/bygr-frontend-component-library';
import React from 'react';
import { useParams } from 'react-router';
import { ProfileInvitationsTable } from './ProfileInvitationsTable';
import { BuyerInvitationsTable } from './BuyerInvitationsTable';

export type InvitationsTab = 'profile' | 'buyers';

interface InvitationsPageProps {
    tab?: InvitationsTab;
}

interface TabSettings {
    id: InvitationsTab;
    name: string;
    component: React.ComponentType;
}

const tabs: TabSettings[] = [
    {
        id: 'profile',
        name: 'Profile Invitations',
        component: ProfileInvitationsTable,
    },
    {
        id: 'buyers',
        name: 'Buyer Invitations',
        component: BuyerInvitationsTable,
    },
];

const InvitationsPage: React.FC<InvitationsPageProps> = (props) => {
    const { tab } = useParams<{ tab?: InvitationsTab }>();
    const activeTab = tab || 'profile';

    return (
        <div>
            <h2>Invitations</h2>
            <Tabs activeTabId={activeTab}>
                {tabs.map((tabConfig) => {
                    const Component = tabConfig.component;
                    return (
                        <LinkTab key={tabConfig.id} id={tabConfig.id} name={tabConfig.name} to={`/invitations/${tabConfig.id}`}>
                            <div>
                                <Component />
                            </div>
                        </LinkTab>
                    );
                })}
            </Tabs>
        </div>
    );
};

export default InvitationsPage;
